import { preloadContentPrerequisites } from '@confluence/content-prerequisites/entry-points/preloadContentPrerequisites.ts';
import { preloadContentTypesHeader } from '@confluence/content-types-header/entry-points/preloadContentTypesHeader.js';
import { fg } from '@confluence/feature-gating';
import { FORGE_MODULE_XEN_MACRO } from '@confluence/forge-ui/entry-points/ForgeModuleType.ts';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList.ts';
import { preloadPageRestrictionsQuery } from '@confluence/page-restrictions-context/entry-points/preloadPageRestrictionsQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { preloadPresenceSettings } from '@confluence/team-presence/entry-points/preloadPresenceSettings.ts';
import { preloadIsSuperAdmin } from '@confluence/super-admin/entry-points/preloadIsSuperAdmin.ts';

export const preloadContentHistoryRoute = async (
	match: RouteMatch,
): Promise<void | any[] | Error[]> => {
	const tasks: Promise<any>[] = [];

	const { contentId, spaceKey } = match.params;

	// ContentHistory renders PagePrerequisites, so it sits behind the same ViewPageGateway
	// AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
	// it issues a request; it is a no-op for everyone else.
	tasks.push(preloadIsSuperAdmin());

	const preloadedSessionContext = getPreloaderFnContext();

	const { cloudId } = preloadedSessionContext;

	// Since this query is not called in ContentPrerequisites when contentId is
	// missing, we should follow the same reasoning and skip preload when content is
	// missing.
	if (contentId) {
		tasks.push(preloadContentPrerequisites(contentId, spaceKey));
	}

	tasks.push(preloadContentTypesHeader(contentId));
	// Standalone Restrictions button needs to have its data preloaded
	tasks.push(preloadPageRestrictionsQuery(contentId, false));

	// Presence Avatar Visibility
	tasks.push(preloadPresenceSettings({ cloudId, spaceKey }));

	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (fg('conf_frontend_forge_static_macro_mvp')) {
		tasks.push(
			preloadUseExtensionList({
				contentId,
				spaceKey,
				moduleType: FORGE_MODULE_XEN_MACRO,
			}),
		);
	}

	return waitForAllReturnWhenError(tasks);
};
